module.exports = __webpack_public_path__ + "img/3_12.54d77081.png";